import { useCallback, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../store';
import { selectMenuHidden, updateMenuHidden } from '../../store/entities/ui';

/**
 * Temporarily hides the sidebar and restores its original state on release.
 * Tracks whether the sidebar was already hidden before the override,
 * so it only restores when it actually changed something.
 */
export const useSidebarOverride = () => {
  const dispatch = useAppDispatch();
  const menuHidden = useAppSelector(selectMenuHidden);
  const menuHiddenRef = useRef(menuHidden);
  const previousStateRef = useRef<boolean | null>(null);

  useEffect(() => {
    menuHiddenRef.current = menuHidden;
  }, [menuHidden]);

  const hideSidebar = useCallback(() => {
    if (previousStateRef.current === null) {
      previousStateRef.current = menuHiddenRef.current;
    }
    dispatch(updateMenuHidden(true));
  }, [dispatch]);

  const restoreSidebar = useCallback(() => {
    if (previousStateRef.current === false) {
      dispatch(updateMenuHidden(false));
    }
    previousStateRef.current = null;
  }, [dispatch]);

  useEffect(() => {
    return () => {
      if (previousStateRef.current === false) {
        dispatch(updateMenuHidden(false));
      }
    };
  }, [dispatch]);

  return { hideSidebar, restoreSidebar };
};
